import React from 'react';
import styled from '@emotion/styled';
import { QuoteCard } from '../molecules';
import { Box, Flex, Image, Link } from '@theme-ui/components';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { useStaticQuery, graphql } from 'gatsby';

const TestimonialQuote = ({
	employeeName,
	employeeDesignation,
	companyName,
	feedback,
	originalId,
	slug,
	isGatsbyImg,
	image,
	alt,
	bgImg,
	contentDirection,
	width,
	height,
	color = '#23B4FB',
	showG2Logo
}) => {

	const { G2_logo } = useStaticQuery(graphql`
		query {
			G2_logo: file(relativePath: { eq: "g2c/G2-logo.png" }) {
				childImageSharp {
					gatsbyImageData(
						width: 30
						placeholder: BLURRED
						layout: CONSTRAINED
					)
				}
			}
		}
	`);

	const contentWidth = width - 54;
	const vertical = contentDirection === 'vertical';
	const flexDirection = vertical ? 'column' : 'row';
    const employeeInfoMarginLeft = vertical ? 0 : '18px';
    const employeeInfoMarginTop = vertical ? 3 : 0;
    const alignItems = vertical ? 'left' : 'center';
	
	const ReviewCard = () => {
		return (
		    <QuoteCard bgImg={bgImg} width={width} height={height} >
			    <Flex sx={{flexDirection: 'column', justifyContent: 'space-between', height: '100%'}}>
			        <Box sx={{ maxWidth: contentWidth }}>
				        <Flex sx={{ flexDirection, alignItems }}>
					        <Box sx={{ width: 79 }}>
						        {isGatsbyImg ? (
						            <GatsbyImage image={getImage(image)} alt={alt} />
						        ) : (
						            <Image src={image} alt={alt} />
						        )}
					        </Box>
					        <Box sx={{ mt: employeeInfoMarginTop, ml: employeeInfoMarginLeft }}>
						        <StyledName sx={{ color }}>{employeeName}</StyledName>
						        <Box sx={{ fontWeight: '500' }}>{employeeDesignation}</Box>
						        {companyName && <Box>{companyName}</Box>}
					        </Box>
				        </Flex>
				        <Box mt={2}>
					        <div dangerouslySetInnerHTML={{ __html: feedback }} />
				        </Box>
			        </Box>
			        {showG2Logo && <Box style={{textAlign: 'end', mt: 1}}>
			            <StyledImage image={getImage(G2_logo)} alt='G2_logo'/>
		            </Box>}
		        </Flex>
		    </QuoteCard>
		);
	};

	return (
	    <Box>
			{ showG2Logo ? (
		        <Link id={`testimonial_link_${originalId}`} href={slug} rel='noopener' target="_blank" color='black'>
			        <ReviewCard />
		        </Link>
	        ) : ( 
			    <ReviewCard />
			)}
		</Box>
	);
};

const StyledName = styled(Box)`
	font-weight: 600;
	font-size: 1.375rem;
	line-height: 28.78px;
	@media (max-width: 768px) {
		font-size: 1rem;
		line-height: 22px;
	}
`;

const StyledImage = styled(GatsbyImage)`
width: 30px;
height: 30px;
position: relative;
left: 18px;
top: 5px;
@media (max-width: 768px) {
    top: 18px;
    left: 0px;
}
`

export default TestimonialQuote;